import { Component, Input } from '@angular/core';
import { HomeTxtsKey } from 'src/app/components/pages/home/h-interfaces/txt-h-keys/home-txt-key.interface';

@Component({
  selector: 'app-feature-highlight',
  templateUrl: './feature-highlight.component.html',
  styleUrl: './feature-highlight.component.scss'
})
export class FeatureHighlightComponent {
  @Input() texts?: HomeTxtsKey;
  @Input() imgFeatureH?: string;

  get titleParts(): [string, string] {
    const parts = this.texts?.featureH_Section?.title?.split('|') ?? ['', ''];
    return [parts[0] ?? '', parts[1] ?? ''];
  }

}
